const getPos = (posCode: string) => {
  return posCodes.find((pos) => pos.code === posCode)?.name;
}

const posCodes = [
  { code: '02', name: 'Telehealth' },
  { code: '03', name: 'School' },
  { code: '11', name: 'Office' },
  { code: '12', name: 'Home' },
  { code: '99', name: 'Other' },
];

const extraPosCodes = [
  { code: '10', name: 'Telehealth in Patient Home' }
];

const optionsByCode99 = [ 'Daycare', 'Pre-school', 'After-school', 'Community', ];
const textValidatePosCode99 = 'POS 99 description';
const posCode99 = '99';
const posCode02 = '02';

export { getPos, posCodes, extraPosCodes, optionsByCode99, textValidatePosCode99, posCode99, posCode02 };